"use strict";
/**
 * @module Session
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../io/codec");
var session_id_1 = require("./../session/session-id");
/**
 * A serialiser for {@link SessionId}
 */
var SessionIdSerialiserClass = /** @class */ (function () {
    function SessionIdSerialiserClass() {
    }
    /**
     * @inheritdoc
     */
    SessionIdSerialiserClass.prototype.read = function (input) {
        var server = Codec.readInt64(input);
        var value = Codec.readInt64(input);
        return new session_id_1.SessionId(server, value);
    };
    /**
     * @inheritdoc
     */
    SessionIdSerialiserClass.prototype.write = function (output, sessionId) {
        Codec.writeInt64(output, sessionId.server);
        Codec.writeInt64(output, sessionId.value);
    };
    return SessionIdSerialiserClass;
}());
exports.SessionIdSerialiserClass = SessionIdSerialiserClass;
/**
 * The {@link BooleanSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.SessionIdSerialiser = new SessionIdSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/session/session-id-serialiser.js
// module id = 109
// module chunks = 1